"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductOfferingType = exports.DollarAmountIncentiveType = exports.DollarAmountIncentiveRoute = exports.LienTradelineConsolidationStrategy = exports.LOW_CONFIDENCE_LIEN_ATTESTATION_TRIGGERS = exports.AllLiensAttestationTrigger = exports.TeaserRateFeatureType = exports.allowsOptionalUserSelectedPrequalDebtSwap = exports.supportsUserSelectedPrequalDebtSwap = exports.USER_SELECTED_PREQUAL_DEBT_SWAP_STRATEGIES = exports.DebtSwapStrategy = exports.ORIGINATION_HOME_UNDERWRITING_MODES = exports.UnderwritingResponseType = exports.PythonBucketProductType = exports.UnderwritingReportName = exports.DEFAULT_PAYMENT_CALCULATOR_MAX_AMOUNT_DOLLARS = exports.ReOriginationOverrideType = exports.LoanApplicationOverrideType = exports.HomeUnderwritingMode = exports.UCC_MAX_APR = exports.AUTO_CREDIT_CARD_ACCOUNT_MAX_APR = exports.HOME_GLOBAL_MIN_FICO_SCORE = exports.CRYPTO_MAX_APR = exports.HOME_CREDIT_CARD_ACCOUNT_MAX_APR = exports.OfferFailureCode = exports.FIXED_TERM_STATED_USAGE_OVERRIDE_VARIANTS = exports.CardholderFeature = exports.FLAT_RATE_MERCHANT_DISCOUNT_RATE_TERM_MONTHS = exports.isDefaultFeeTier = exports.FEE_APR_TRADEOFF_VARIANTS = exports.DIGITAL_AVEN_CASH_FEE_APR_TRADEOFF_VARIANTS = exports.FIRST_DRAW_FEE_APR_TRADEOFF_VARIANTS = exports.PolicyVariantType = exports.CreditBureau = exports.PolicyVariantConfigType = void 0;
/* @TranslateToPython */
var PolicyVariantConfigType;
(function (PolicyVariantConfigType) {
    PolicyVariantConfigType["Base"] = "Base";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantConfigType["DeprecatedDoNotUseNoo"] = "Noo";
})(PolicyVariantConfigType || (exports.PolicyVariantConfigType = PolicyVariantConfigType = {}));
/* @TranslateToPython */
var CreditBureau;
(function (CreditBureau) {
    CreditBureau["EXPERIAN"] = "EXPERIAN";
    CreditBureau["TRANSUNION"] = "TRANSUNION";
    CreditBureau["EQUIFAX"] = "EQUIFAX";
})(CreditBureau || (exports.CreditBureau = CreditBureau = {}));
/* @TranslateToPython */
var PolicyVariantType;
(function (PolicyVariantType) {
    PolicyVariantType["baseVariant"] = "baseVariant";
    PolicyVariantType["RewardsBtHigherLimitVariant"] = "RewardsBtHigherLimitVariant";
    /**
     * Marker variant indicating this spec should use the HELOC refi policy path.
     * In the current Python endpoint, this translates to `getHelocRefiPolicy: true`.
     * In the future multi-spec endpoint, this variant will be applied like any other.
     */
    PolicyVariantType["helocRefiBaseSwapVariant"] = "helocRefiBaseSwapVariant";
    PolicyVariantType["PurchaseCltvReduction50BpsDiscountVariant"] = "PurchaseCltvReduction50BpsDiscountVariant";
    PolicyVariantType["PurchaseLenderFee175BpsApr25BpsVariant"] = "PurchaseLenderFee175BpsApr25BpsVariant";
    PolicyVariantType["PurchaseLenderFee125BpsApr50BpsVariant"] = "PurchaseLenderFee125BpsApr50BpsVariant";
    PolicyVariantType["PurchaseLenderFee100BpsApr75BpsVariant"] = "PurchaseLenderFee100BpsApr75BpsVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariant"] = "NooVariant";
    PolicyVariantType["NooEnabledVariant"] = "NooEnabledVariant";
    PolicyVariantType["OldIgnoreStatedUsageVariant"] = "IgnoreStatedUsageLineSizeAdjusterVariant";
    PolicyVariantType["IgnoreStatedUsageVariant"] = "IgnoreStatedUsageVariant";
    PolicyVariantType["MerchantDiscountRate0PctVariant"] = "MerchantDiscountRate0PctVariant";
    PolicyVariantType["MerchantDiscountRate2PctVariant"] = "MerchantDiscountRate2PctVariant";
    PolicyVariantType["MerchantDiscountRate4PctVariant"] = "MerchantDiscountRate4PctVariant";
    PolicyVariantType["MerchantDiscountRate5PctVariant"] = "MerchantDiscountRate5PctVariant";
    PolicyVariantType["MerchantDiscountRate6PctVariant"] = "MerchantDiscountRate6PctVariant";
    PolicyVariantType["MerchantDiscountRate8PctVariant"] = "MerchantDiscountRate8PctVariant";
    PolicyVariantType["MerchantDiscountRate10PctVariant"] = "MerchantDiscountRate10PctVariant";
    PolicyVariantType["IgnoreStatedUsage400KVariant"] = "IgnoreStatedUsage400KVariant";
    PolicyVariantType["IgnoreStatedUsage25kVariant"] = "IgnoreStatedUsage25kVariant";
    PolicyVariantType["IgnoreStatedUsage25kVariantFixedTerm30YearVariant"] = "IgnoreStatedUsage25kVariantFixedTerm30YearVariant";
    PolicyVariantType["IgnoreStatedUsage50kVariant"] = "IgnoreStatedUsage50kVariant";
    PolicyVariantType["IgnoreStatedUsage50kVariantFixedTerm30YearVariant"] = "IgnoreStatedUsage50kVariantFixedTerm30YearVariant";
    PolicyVariantType["IgnoreStatedUsageVariantPrimeV3Variant"] = "IgnoreStatedUsageVariantPrimeV3Variant";
    PolicyVariantType["TaxFreeVariant"] = "TaxFreeVariant";
    PolicyVariantType["TexasVariant"] = "TexasVariant";
    // Inverse of TexasVariant: enables the non-Texas-property hardcut so a TX-property home is
    // hardcut out of this spec. Used to disable a product line in Texas.
    PolicyVariantType["TexasDisabledVariant"] = "TexasDisabledVariant";
    PolicyVariantType["PrimeV2Variant"] = "PrimeV2Variant";
    PolicyVariantType["PrimeV3Variant"] = "PrimeV3Variant";
    PolicyVariantType["IncreasedBtCoVariant"] = "IncreasedBtCoVariant";
    PolicyVariantType["FixedTerm1YearVariant"] = "FixedTerm1YearVariant";
    PolicyVariantType["FixedTerm2YearVariant"] = "FixedTerm2YearVariant";
    PolicyVariantType["FixedTerm3YearVariant"] = "FixedTerm3YearVariant";
    PolicyVariantType["FixedTerm4YearVariant"] = "FixedTerm4YearVariant";
    PolicyVariantType["FixedTerm5YearVariant"] = "FixedTerm5YearVariant";
    PolicyVariantType["FixedTerm10YearVariant"] = "FixedTerm10YearVariant";
    PolicyVariantType["FixedTerm15YearVariant"] = "FixedTerm15YearVariant";
    PolicyVariantType["FixedTerm20YearVariant"] = "FixedTerm20YearVariant";
    PolicyVariantType["FixedTerm30YearVariant"] = "FixedTerm30YearVariant";
    // ISU + FMP variants
    PolicyVariantType["IgnoreStatedUsageVariantFixedTerm5YearVariant"] = "IgnoreStatedUsageVariantFixedTerm5YearVariant";
    PolicyVariantType["IgnoreStatedUsageVariantFixedTerm10YearVariant"] = "IgnoreStatedUsageVariantFixedTerm10YearVariant";
    PolicyVariantType["IgnoreStatedUsageVariantFixedTerm15YearVariant"] = "IgnoreStatedUsageVariantFixedTerm15YearVariant";
    PolicyVariantType["IgnoreStatedUsageVariantFixedTerm30YearVariant"] = "IgnoreStatedUsageVariantFixedTerm30YearVariant";
    // NOO + FMP variants
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantFixedTerm5YearVariant"] = "NooVariantFixedTerm5YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantFixedTerm10YearVariant"] = "NooVariantFixedTerm10YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantFixedTerm15YearVariant"] = "NooVariantFixedTerm15YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantFixedTerm30YearVariant"] = "NooVariantFixedTerm30YearVariant";
    // Conduit(Limited Revolving) variants
    PolicyVariantType["ConduitFixedTerm15YearVariant"] = "ConduitFixedTerm15YearVariant";
    PolicyVariantType["ConduitFixedTerm30YearVariant"] = "ConduitFixedTerm30YearVariant";
    // Conduit(Limited Revolving) variants with ISU
    PolicyVariantType["IgnoreStatedUsageVariantConduitFixedTerm15YearVariant"] = "IgnoreStatedUsageVariantConduitFixedTerm15YearVariant";
    PolicyVariantType["IgnoreStatedUsageVariantConduitFixedTerm30YearVariant"] = "IgnoreStatedUsageVariantConduitFixedTerm30YearVariant";
    // Special casing on TaxFreeVariantPrimeV2Variant.
    PolicyVariantType["TaxFreeVariantPrimeV2Variant"] = "TaxFreeVariantPrimeV2Variant";
    PolicyVariantType["TaxFreeVariantPrimeV3Variant"] = "TaxFreeVariantPrimeV3Variant";
    // For Auto Refinance
    PolicyVariantType["TermExtensionVariant"] = "TermExtensionVariant";
    // For manual offers(APR / Line Size manually set, see manualOffer.ts in aven_backend)
    PolicyVariantType["ManualOfferVariant"] = "ManualOfferVariant";
    // Debt swap promo variants (no APR surcharge — promo rate for users who transfer debt)
    PolicyVariantType["DebtSwapAprIncentiveFixedTerm3YearVariant"] = "DebtSwapAprIncentiveFixedTerm3YearVariant";
    PolicyVariantType["DebtSwapAprIncentiveFixedTerm4YearVariant"] = "DebtSwapAprIncentiveFixedTerm4YearVariant";
    PolicyVariantType["DebtSwapAprIncentiveFixedTerm5YearVariant"] = "DebtSwapAprIncentiveFixedTerm5YearVariant";
    // Fee swap variants (lower APR + one-time fee, vs standard no-fee higher APR)
    PolicyVariantType["FeeSwapFixedTerm3YearVariant"] = "FeeSwapFixedTerm3YearVariant";
    PolicyVariantType["FeeSwapFixedTerm4YearVariant"] = "FeeSwapFixedTerm4YearVariant";
    PolicyVariantType["FeeSwapFixedTerm5YearVariant"] = "FeeSwapFixedTerm5YearVariant";
    // Full debt swap bonus
    PolicyVariantType["FullDebtSwapBonus"] = "FullDebtSwapBonus";
    PolicyVariantType["FullDebtSwapBonusFixedTerm5YearVariant"] = "FullDebtSwapBonusFixedTerm5YearVariant";
    PolicyVariantType["FullDebtSwapBonusFixedTerm10YearVariant"] = "FullDebtSwapBonusFixedTerm10YearVariant";
    PolicyVariantType["FullDebtSwapBonusFixedTerm15YearVariant"] = "FullDebtSwapBonusFixedTerm15YearVariant";
    PolicyVariantType["FullDebtSwapBonusFixedTerm20YearVariant"] = "FullDebtSwapBonusFixedTerm20YearVariant";
    PolicyVariantType["FullDebtSwapBonusFixedTerm30YearVariant"] = "FullDebtSwapBonusFixedTerm30YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseFullDebtSwapBonusNooVariantFixedTerm5YearVariant"] = "FullDebtSwapBonusNooVariantFixedTerm5YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseFullDebtSwapBonusNooVariantFixedTerm10YearVariant"] = "FullDebtSwapBonusNooVariantFixedTerm10YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseFullDebtSwapBonusNooVariantFixedTerm15YearVariant"] = "FullDebtSwapBonusNooVariantFixedTerm15YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseFullDebtSwapBonusNooVariantFixedTerm20YearVariant"] = "FullDebtSwapBonusNooVariantFixedTerm20YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseFullDebtSwapBonusNooVariantFixedTerm30YearVariant"] = "FullDebtSwapBonusNooVariantFixedTerm30YearVariant";
    // Heloc Refi policy variant to generate offer with starting line size as 2nd lien balance + 5k;
    PolicyVariantType["HelocRefi2ndLienAttestedBalanceVariant"] = "HelocRefi2ndLienAttestedBalanceVariant";
    PolicyVariantType["HelocRefi2ndLienAttestedBalanceFixedTerm5YearVariant"] = "HelocRefi2ndLienAttestedBalanceFixedTerm5YearVariant";
    PolicyVariantType["HelocRefi2ndLienAttestedBalanceFixedTerm10YearVariant"] = "HelocRefi2ndLienAttestedBalanceFixedTerm10YearVariant";
    PolicyVariantType["HelocRefi2ndLienAttestedBalanceFixedTerm15YearVariant"] = "HelocRefi2ndLienAttestedBalanceFixedTerm15YearVariant";
    PolicyVariantType["HelocRefi2ndLienAttestedBalanceFixedTerm30YearVariant"] = "HelocRefi2ndLienAttestedBalanceFixedTerm30YearVariant";
    // Heloc Refi policy variant for stated usage plus second lien balance
    PolicyVariantType["HelocRefiStatedUsagePlusSecondLienBalanceVariant"] = "HelocRefiStatedUsagePlusSecondLienBalanceVariant";
    PolicyVariantType["HelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm5YearVariant"] = "HelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm5YearVariant";
    PolicyVariantType["HelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm10YearVariant"] = "HelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm10YearVariant";
    PolicyVariantType["HelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm15YearVariant"] = "HelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm15YearVariant";
    PolicyVariantType["HelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm30YearVariant"] = "HelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm30YearVariant";
    // NOO + Heloc Refi Stated Usage Plus Second Lien Balance variants
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantHelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm5YearVariant"] = "NooVariantHelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm5YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantHelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm10YearVariant"] = "NooVariantHelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm10YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantHelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm15YearVariant"] = "NooVariantHelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm15YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantHelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm30YearVariant"] = "NooVariantHelocRefiStatedUsagePlusSecondLienBalanceVariantFixedTerm30YearVariant";
    // Generalized Refi Stated Usage Plus Refi Balance variants (works for multi-lien refi)
    PolicyVariantType["RefiStatedUsagePlusRefiBalanceVariant"] = "RefiStatedUsagePlusRefiBalanceVariant";
    PolicyVariantType["RefiStatedUsagePlusRefiBalanceVariantFixedTerm5YearVariant"] = "RefiStatedUsagePlusRefiBalanceVariantFixedTerm5YearVariant";
    PolicyVariantType["RefiStatedUsagePlusRefiBalanceVariantFixedTerm10YearVariant"] = "RefiStatedUsagePlusRefiBalanceVariantFixedTerm10YearVariant";
    PolicyVariantType["RefiStatedUsagePlusRefiBalanceVariantFixedTerm15YearVariant"] = "RefiStatedUsagePlusRefiBalanceVariantFixedTerm15YearVariant";
    PolicyVariantType["RefiStatedUsagePlusRefiBalanceVariantFixedTerm30YearVariant"] = "RefiStatedUsagePlusRefiBalanceVariantFixedTerm30YearVariant";
    // NOO + Refi Stated Usage Plus Refi Balance variants
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantRefiStatedUsagePlusRefiBalanceVariantFixedTerm5YearVariant"] = "NooVariantRefiStatedUsagePlusRefiBalanceVariantFixedTerm5YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantRefiStatedUsagePlusRefiBalanceVariantFixedTerm10YearVariant"] = "NooVariantRefiStatedUsagePlusRefiBalanceVariantFixedTerm10YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantRefiStatedUsagePlusRefiBalanceVariantFixedTerm15YearVariant"] = "NooVariantRefiStatedUsagePlusRefiBalanceVariantFixedTerm15YearVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantRefiStatedUsagePlusRefiBalanceVariantFixedTerm30YearVariant"] = "NooVariantRefiStatedUsagePlusRefiBalanceVariantFixedTerm30YearVariant";
    // MOAP HELOC Refi payoff-term variants — amortize 2nd-lien balance over 15y (small line)
    // or 30y (large line) and treat the residual as MOAP revolving.
    PolicyVariantType["MoapRefi15YearPayoffVariant"] = "MoapRefi15YearPayoffVariant";
    PolicyVariantType["MoapRefi30YearPayoffVariant"] = "MoapRefi30YearPayoffVariant";
    PolicyVariantType["MoapRefi15YearPayoffIgnoreStatedUsageVariant"] = "MoapRefi15YearPayoffIgnoreStatedUsageVariant";
    PolicyVariantType["MoapRefi30YearPayoffIgnoreStatedUsageVariant"] = "MoapRefi30YearPayoffIgnoreStatedUsageVariant";
    PolicyVariantType["MoapRefi15YearPayoffRefiStatedUsagePlusRefiBalanceVariant"] = "MoapRefi15YearPayoffRefiStatedUsagePlusRefiBalanceVariant";
    PolicyVariantType["MoapRefi30YearPayoffRefiStatedUsagePlusRefiBalanceVariant"] = "MoapRefi30YearPayoffRefiStatedUsagePlusRefiBalanceVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantMoapRefi15YearPayoffVariant"] = "NooVariantMoapRefi15YearPayoffVariant";
    /** @deprecated NOO is handled natively by homeBasePolicy runtime flags */
    PolicyVariantType["DeprecatedDoNotUseNooVariantMoapRefi30YearPayoffVariant"] = "NooVariantMoapRefi30YearPayoffVariant";
    // Stated usage override variants (treats OTHER like HOME_IMPROVEMENT with fee/APR surcharges)
    PolicyVariantType["StatedUsageOverrideVariant"] = "StatedUsageOverrideVariant";
    PolicyVariantType["StatedUsageOverrideVariantFixedTerm3YearVariant"] = "StatedUsageOverrideVariantFixedTerm3YearVariant";
    PolicyVariantType["StatedUsageOverrideVariantFixedTerm4YearVariant"] = "StatedUsageOverrideVariantFixedTerm4YearVariant";
    PolicyVariantType["StatedUsageOverrideVariantFixedTerm5YearVariant"] = "StatedUsageOverrideVariantFixedTerm5YearVariant";
    // Crypto OLTV variants
    PolicyVariantType["Crypto30PctOltvVariant"] = "Crypto30PctOltvVariant";
    PolicyVariantType["Crypto50PctOltvVariant"] = "Crypto50PctOltvVariant";
    PolicyVariantType["Crypto70PctOltvVariant"] = "Crypto70PctOltvVariant";
    // Prequal slider variants
    PolicyVariantType["AvenCashPrequalSliderConfigVariant"] = "AvenCashPrequalSliderConfigVariant";
    PolicyVariantType["AvenCashPrequalUserSelectedDebtSwapVariant"] = "AvenCashPrequalUserSelectedDebtSwapVariant";
    // Legacy composite: historically this coupled slider config with user-selected debt swap by mistake.
    // Existing configs may still use it for backwards compatibility, but new configs/templates should
    // compose AvenCashPrequalSliderConfigVariant and AvenCashPrequalUserSelectedDebtSwapVariant directly.
    PolicyVariantType["AvenCashPrequalSliderVariant"] = "AvenCashPrequalSliderVariant";
    /**
     * First-lien HELOC refi slider config variant — makes the FLH policy slider-compatible so the
     * requote path can size cash-out to the applicant's selected AC line size at display time.
     * Mirrors AvenCashPrequalSliderConfigVariant but scoped to the FLH policy family.
     */
    PolicyVariantType["FlhPrequalSliderConfigVariant"] = "FlhPrequalSliderConfigVariant";
    PolicyVariantType["AvenCashMegaLineVariant"] = "AvenCashMegaLineVariant";
    PolicyVariantType["MoapPrequalSliderVariant"] = "MoapPrequalSliderVariant";
    // Enables the additional HELOC hardcuts, which read the borrower existing Aven accounts report.
    PolicyVariantType["AdditionalHelocVariant"] = "AdditionalHelocVariant";
    // Enables the Aven HELOC refinance hardcuts, which read the borrower existing Aven accounts report.
    PolicyVariantType["AvenHelocRefinanceVariant"] = "AvenHelocRefinanceVariant";
    // First draw fee / APR tradeoff variants (stackable onto prequal slider policy variants).
    PolicyVariantType["FirstDrawFeeAprTradeoff39Fee40bps"] = "FirstDrawFeeAprTradeoff39Fee40bps";
    PolicyVariantType["FirstDrawFeeAprTradeoff29Fee80bps"] = "FirstDrawFeeAprTradeoff29Fee80bps";
    PolicyVariantType["FirstDrawFeeAprTradeoff19Fee120bps"] = "FirstDrawFeeAprTradeoff19Fee120bps";
    PolicyVariantType["FirstDrawFeeAprTradeoff399Fee50bps"] = "FirstDrawFeeAprTradeoff399Fee50bps";
    PolicyVariantType["FirstDrawFeeAprTradeoff299Fee75bps"] = "FirstDrawFeeAprTradeoff299Fee75bps";
    PolicyVariantType["FirstDrawFeeAprTradeoff199Fee125bps"] = "FirstDrawFeeAprTradeoff199Fee125bps";
    // Liens-to-refi variants: each sets the policy LIENS_TO_REFI (and a matching MAX_LIEN_POSITION)
    // so the empty base (LIENS_TO_REFI=[]) can offer each refi combination as its own spec. These
    // carry [1] / [1,2] / [2] / [2,3] / [1,2,3] respectively; the empty base is the no-refi offer.
    PolicyVariantType["LiensToRefiFirstLienVariant"] = "LiensToRefiFirstLienVariant";
    PolicyVariantType["LiensToRefiFirstAndSecondLienVariant"] = "LiensToRefiFirstAndSecondLienVariant";
    PolicyVariantType["LiensToRefiSecondLienVariant"] = "LiensToRefiSecondLienVariant";
    PolicyVariantType["LiensToRefiSecondAndThirdLienVariant"] = "LiensToRefiSecondAndThirdLienVariant";
    PolicyVariantType["LiensToRefiFirstSecondAndThirdLienVariant"] = "LiensToRefiFirstSecondAndThirdLienVariant";
    PolicyVariantType["FirstDrawFeeAprTradeoff39Fee50bps"] = "FirstDrawFeeAprTradeoff39Fee50bps";
    PolicyVariantType["FirstDrawFeeAprTradeoff29Fee75bps"] = "FirstDrawFeeAprTradeoff29Fee75bps";
    PolicyVariantType["FirstDrawFeeAprTradeoff19Fee125bps"] = "FirstDrawFeeAprTradeoff19Fee125bps";
})(PolicyVariantType || (exports.PolicyVariantType = PolicyVariantType = {}));
/* @TranslateToPython */
exports.FIRST_DRAW_FEE_APR_TRADEOFF_VARIANTS = [
    PolicyVariantType.FirstDrawFeeAprTradeoff399Fee50bps,
    PolicyVariantType.FirstDrawFeeAprTradeoff299Fee75bps,
    PolicyVariantType.FirstDrawFeeAprTradeoff199Fee125bps,
];
/* @TranslateToPython */
exports.DIGITAL_AVEN_CASH_FEE_APR_TRADEOFF_VARIANTS = [
    PolicyVariantType.FirstDrawFeeAprTradeoff39Fee50bps,
    PolicyVariantType.FirstDrawFeeAprTradeoff29Fee75bps,
    PolicyVariantType.FirstDrawFeeAprTradeoff19Fee125bps,
];
exports.FEE_APR_TRADEOFF_VARIANTS = [...exports.FIRST_DRAW_FEE_APR_TRADEOFF_VARIANTS, ...exports.DIGITAL_AVEN_CASH_FEE_APR_TRADEOFF_VARIANTS];
const FEE_APR_TRADEOFF_VARIANT_SET = new Set(exports.FEE_APR_TRADEOFF_VARIANTS);
const isDefaultFeeTier = (variants) => !variants.some((variant) => FEE_APR_TRADEOFF_VARIANT_SET.has(variant));
exports.isDefaultFeeTier = isDefaultFeeTier;
exports.FLAT_RATE_MERCHANT_DISCOUNT_RATE_TERM_MONTHS = [60, 120, 180, 240];
/* @TranslateToPython */
var CardholderFeature;
(function (CardholderFeature) {
    CardholderFeature["hasCard"] = "hasCard";
    CardholderFeature["rewardsBtUpsell"] = "rewardsBtUpsell";
    // MOAP→AvenCash 3% CB + OTB upgrade variant: enables OTB-aware account agreement supplement and FE upgrade UX.
    CardholderFeature["threePctCbOtbUpgrade"] = "threePctCbOtbUpgrade";
    CardholderFeature["flatRateMdr"] = "flatRateMdr";
})(CardholderFeature || (exports.CardholderFeature = CardholderFeature = {}));
exports.FIXED_TERM_STATED_USAGE_OVERRIDE_VARIANTS = new Set([
    PolicyVariantType.StatedUsageOverrideVariantFixedTerm3YearVariant,
    PolicyVariantType.StatedUsageOverrideVariantFixedTerm4YearVariant,
    PolicyVariantType.StatedUsageOverrideVariantFixedTerm5YearVariant,
]);
/**
 * Reasons why Aven card offer generation may have failed. Notice this is a superset of
 * UnderwritingFailureCode, meant to account for both underwriting failures and non-underwriting
 * failures. This is our external error interface communicated to our client code.
 */
var OfferFailureCode;
(function (OfferFailureCode) {
    OfferFailureCode["homeOwnership"] = "homeOwnership";
    OfferFailureCode["homeOwnershipRemedy"] = "homeOwnershipRemedy";
    OfferFailureCode["homeOwnershipRemedyTokenMatch"] = "homeOwnershipRemedyTokenMatch";
    OfferFailureCode["homeIsLLC"] = "homeIsLLC";
    OfferFailureCode["homeIsTrustAndRin"] = "homeIsTrustAndRin";
    OfferFailureCode["homeIsTrustAndNOO"] = "homeIsTrustAndNOO";
    OfferFailureCode["homeIsTrustInNotSupportedState"] = "homeIsTrustInNotSupportedState";
    OfferFailureCode["humanInvestigate"] = "humanInvestigate";
    OfferFailureCode["involuntaryLienFound"] = "involuntaryLienFound";
    OfferFailureCode["activeForeclosureFound"] = "activeForeclosureFound";
    OfferFailureCode["ofacVerification"] = "ofacVerification";
    OfferFailureCode["denied"] = "denied";
    OfferFailureCode["expired"] = "expired";
    OfferFailureCode["priorApplicationFound"] = "priorApplicationFound";
    OfferFailureCode["offerAddCoApplicant"] = "offerAddCoApplicant";
    OfferFailureCode["blockedApplication"] = "blockedApplication";
    OfferFailureCode["underwritingFail"] = "underwritingFail";
    OfferFailureCode["disputableProviderData"] = "disputableProviderData";
    OfferFailureCode["lienInformationVerification"] = "lienInformationVerification";
    OfferFailureCode["missingLienAttestation"] = "lienAttestationMissing";
    OfferFailureCode["missingAppraisal"] = "missingAppraisal";
    OfferFailureCode["missingAppraisalCollectDetails"] = "missingAppraisalCollectDetails";
    OfferFailureCode["withdrawn"] = "withdrawn";
    OfferFailureCode["uccInsufficientIncome"] = "uccInsufficientIncome";
    OfferFailureCode["uccAutoAccept"] = "uccAutoAccept";
    OfferFailureCode["cryptoAutoAccept"] = "cryptoAutoAccept";
})(OfferFailureCode || (exports.OfferFailureCode = OfferFailureCode = {}));
/** @TranslateToPython @TranslateToEnum */
exports.HOME_CREDIT_CARD_ACCOUNT_MAX_APR = 0.18;
/** @TranslateToPython @TranslateToEnum */
exports.CRYPTO_MAX_APR = 0.18;
/** @TranslateToPython @TranslateToEnum */
exports.HOME_GLOBAL_MIN_FICO_SCORE = 620;
/**
 * @TranslateToPython @TranslateToEnum
 * not currently used
 */
exports.AUTO_CREDIT_CARD_ACCOUNT_MAX_APR = 0.2;
/** @TranslateToPython @TranslateToEnum */
exports.UCC_MAX_APR = 0.36;
/**  @TranslateToPython @TranslateToEnum @TranslateToRust  */
var HomeUnderwritingMode;
(function (HomeUnderwritingMode) {
    // TODO: split out origination for preQualificatoin and qualification UW
    HomeUnderwritingMode["origination"] = "origination";
    HomeUnderwritingMode["experianOnly"] = "experianOnly";
    HomeUnderwritingMode["annualRenewal"] = "annualRenewal";
    HomeUnderwritingMode["preAccountApprovalChecks"] = "preAccountApprovalChecks";
    /** @deprecated CnG was retired 2026-09-03 TODO: prepend key with underscore */
    HomeUnderwritingMode["postAccountOpeningLienCheck"] = "postAccountOpeningLienCheck";
    HomeUnderwritingMode["lineSizeIncrease"] = "lineSizeIncrease";
    /** @deprecated Historical PDR discriminator used by audit queries; no execution path. */
    HomeUnderwritingMode["lineSizeIncreaseExperianOnly"] = "lineSizeIncreaseExperianOnly";
    HomeUnderwritingMode["aprReduction"] = "aprReduction";
    /** @deprecated We now originate mortgages. */
    HomeUnderwritingMode["mortgageBrokering"] = "mortgageBrokering";
    HomeUnderwritingMode["mortgageLienInfoCalculation"] = "mortgageLienInfoCalculation";
    HomeUnderwritingMode["lienInfoCalculation"] = "lienInfoCalculation";
    HomeUnderwritingMode["fullReUnderwriting"] = "fullReUnderwriting";
    HomeUnderwritingMode["getOrderedLienDetails"] = "getOrderedLienDetails";
    HomeUnderwritingMode["parsePlaidReport"] = "parsePlaidReport";
    HomeUnderwritingMode["ucc"] = "ucc";
    HomeUnderwritingMode["lienOverride"] = "lienOverride";
    /**
     * Multi-spec offer generation mode.
     *
     * In this mode, Python evaluates multiple immutable underwriting specs in one call
     * and returns one decision (offer or denial) per spec. Backend code should treat
     * this as the multi-spec world and create one UnderwritingDecision per uwSpecId.
     */
    HomeUnderwritingMode["multiSpecOffers"] = "multiSpecOffers";
    HomeUnderwritingMode["originationWithExistingReports"] = "originationWithExistingReports";
    HomeUnderwritingMode["originationWithExistingReportsExceptSoftPull"] = "originationWithExistingReportsExceptSoftPull";
})(HomeUnderwritingMode || (exports.HomeUnderwritingMode = HomeUnderwritingMode = {}));
/**  @TranslateToPython @TranslateToEnum  */
var LoanApplicationOverrideType;
(function (LoanApplicationOverrideType) {
    LoanApplicationOverrideType["thirdLien"] = "thirdLien";
    LoanApplicationOverrideType["lienPosition"] = "lienPosition";
    LoanApplicationOverrideType["involuntaryLien"] = "involuntaryLien";
    LoanApplicationOverrideType["activeForeclosure"] = "activeForeclosure";
    LoanApplicationOverrideType["avmValue"] = "avmValue";
    LoanApplicationOverrideType["appraisalValue"] = "appraisalValue";
    LoanApplicationOverrideType["homeBalance"] = "homeBalance";
    LoanApplicationOverrideType["firstLienBalance"] = "firstLienBalance";
    LoanApplicationOverrideType["firstLienMonthlyPayment"] = "firstLienMonthlyPayment";
    LoanApplicationOverrideType["secondLienBalance"] = "secondLienBalance";
    LoanApplicationOverrideType["secondLienMonthlyPayment"] = "secondLienMonthlyPayment";
    LoanApplicationOverrideType["firstLienOriginalAmount"] = "firstLienOriginalAmount";
    LoanApplicationOverrideType["firstLienStartDate"] = "firstLienStartDate";
    LoanApplicationOverrideType["secondLienOriginalAmount"] = "secondLienOriginalAmount";
    LoanApplicationOverrideType["secondLienStartDate"] = "secondLienStartDate";
    LoanApplicationOverrideType["postLineMonthlyDebtPayments"] = "postLineMonthlyDebtPayments";
    LoanApplicationOverrideType["additionalDebtSwapBonusOverride"] = "additionalDebtSwapBonusOverride";
    LoanApplicationOverrideType["homeOwnershipAgeMonths"] = "homeOwnershipAgeMonths";
    LoanApplicationOverrideType["landUse"] = "landUse";
    LoanApplicationOverrideType["lotAreaAcres"] = "lotAreaAcres";
    LoanApplicationOverrideType["vestingOwnershipRight"] = "vestingOwnershipRight";
    LoanApplicationOverrideType["mlsListingStatus"] = "mlsListingStatus";
    /** @deprecated kept for backcompat when parsing off loan application */
    LoanApplicationOverrideType["underwritingRuleCategories"] = "underwritingRuleCategories";
    LoanApplicationOverrideType["minimumGrossAnnualIncomeRequiredForOffer"] = "minimumGrossAnnualIncomeRequiredForOffer";
    LoanApplicationOverrideType["minimumGrossAnnualIncomeRequiredForMinOffer"] = "minimumGrossAnnualIncomeRequiredForMinOffer";
    LoanApplicationOverrideType["minimumGrossAnnualIncomeRequiredForPQOffer"] = "minimumGrossAnnualIncomeRequiredForPQOffer";
    LoanApplicationOverrideType["pendingAprPricingRequest"] = "pendingAprPricingRequest";
    LoanApplicationOverrideType["aprPricingRequest"] = "aprPricingRequest";
    LoanApplicationOverrideType["offerTermAprReduction"] = "offerTermAprReduction";
    LoanApplicationOverrideType["offerTermAprReductionTarget"] = "offerTermAprReductionTarget";
    LoanApplicationOverrideType["offerTermAprTarget"] = "offerTermAprTarget";
    LoanApplicationOverrideType["forceStatedUsageVariant"] = "forceStatedUsageVariant";
    // Excludes a historical denied application from the direct-origin denied-prior threshold.
    // Set via /ops/setLoanApplicationOverride before reapplication: prequal can mark the new LA
    // duplicate before ops can attach an override. Partner-originated denials are already exempt.
    // No Python UW meaning.
    LoanApplicationOverrideType["bypassPriorDenialReapplyBlock"] = "bypassPriorDenialReapplyBlock";
    LoanApplicationOverrideType["plaidNameMatch"] = "plaidNameMatch";
})(LoanApplicationOverrideType || (exports.LoanApplicationOverrideType = LoanApplicationOverrideType = {}));
/**
 * The kinds of override that can be applied to a loan application when re-originating it via a dry run.
 * Each variant of the backend ReOriginationOverride union is discriminated on this enum. Lives here (shared)
 * so the mloCrm contract can type its re-underwrite input against it without casting.
 */
var ReOriginationOverrideType;
(function (ReOriginationOverrideType) {
    /** Replace the application's ordered lien details (the lien reparation / attestation flow). */
    ReOriginationOverrideType["lienAttestation"] = "lienAttestation";
    /**
     * Append a generic {@link LoanApplicationOverride} (e.g. offerTermAprTarget) to the application. Named
     * `appendLoanApplicationOverride` (not `loanApplicationOverride`) to make clear this is a re-origination
     * action that *appends* to the LA's `loan_application_overrides`, not that column itself.
     */
    ReOriginationOverrideType["appendLoanApplicationOverride"] = "appendLoanApplicationOverride";
    // First-lien-refi requires a stated first lien APR to generate offers
    ReOriginationOverrideType["firstLienAprAttestation"] = "firstLienAprAttestation";
})(ReOriginationOverrideType || (exports.ReOriginationOverrideType = ReOriginationOverrideType = {}));
exports.DEFAULT_PAYMENT_CALCULATOR_MAX_AMOUNT_DOLLARS = 400_000;
/**  @TranslateToPython @TranslateToEnum  */
var UnderwritingReportName;
(function (UnderwritingReportName) {
    UnderwritingReportName["AppraisalData"] = "AppraisalData";
    UnderwritingReportName["AporValueReport"] = "AporValueReport";
    UnderwritingReportName["ApplicantReport"] = "ApplicantReport";
    UnderwritingReportName["AutoApplicantReport"] = "AutoApplicantReport";
    UnderwritingReportName["AutoApplicationReport"] = "AutoApplicationReport";
    UnderwritingReportName["AvenAccountData"] = "AvenAccountData";
    UnderwritingReportName["BusinessOwnershipVerificationReport"] = "BusinessOwnershipVerificationReport";
    UnderwritingReportName["AvenVerifiedMerchantReport"] = "AvenVerifiedMerchantReport";
    /** @deprecated Use AvenVerifiedMerchantReport */
    UnderwritingReportName["ContractorTierReport"] = "ContractorTierReport";
    UnderwritingReportName["CoreLogicInvoluntaryLiensReport"] = "CoreLogicInvoluntaryLiensReport";
    UnderwritingReportName["CoreLogicSnapshotReport"] = "CoreLogicSnapshotReport";
    UnderwritingReportName["CoreLogicSubjectPropertyDetailReport"] = "CoreLogicSubjectPropertyDetailReport";
    UnderwritingReportName["CoreLogicTHVRiskManagementReport"] = "CoreLogicTHVRiskManagementReport";
    UnderwritingReportName["ClearCapitalAvmReport"] = "ClearCapitalAvmReport";
    UnderwritingReportName["CoreLogicTransactionHistoryReport"] = "CoreLogicTransactionHistoryReport";
    UnderwritingReportName["CryptoCardBalancesReport"] = "CryptoCardBalancesReport";
    UnderwritingReportName["CryptoCardLineSizesReport"] = "CryptoCardLineSizesReport";
    UnderwritingReportName["CryptoMaintenanceStatesReport"] = "CryptoMaintenanceStatesReport";
    UnderwritingReportName["CryptoPricesReport"] = "CryptoPricesReport";
    UnderwritingReportName["CryptoWalletBalancesReport"] = "CryptoWalletBalancesReport";
    UnderwritingReportName["DebtSwapTradelineSelectionsReport"] = "DebtSwapTradelineSelectionsReport";
    UnderwritingReportName["DataTreeProcisionPremierReport"] = "DataTreeProcisionPremierReport";
    UnderwritingReportName["DataTreePropertyReport"] = "DataTreePropertyReport";
    UnderwritingReportName["EquifaxReport"] = "EquifaxReport";
    UnderwritingReportName["ExperianReport"] = "ExperianReport";
    UnderwritingReportName["FidelityPropertyReport"] = "FidelityPropertyReport";
    UnderwritingReportName["FraudFlagReport"] = "FraudFlagReport";
    UnderwritingReportName["GeminiReport"] = "GeminiReport";
    UnderwritingReportName["HomeReport"] = "HomeReport";
    UnderwritingReportName["HomeSearchReport"] = "HomeSearchReport";
    UnderwritingReportName["HouseCanaryAgileValueReport"] = "HouseCanaryAgileValueReport";
    UnderwritingReportName["HouseCanaryLtvReport"] = "HouseCanaryLtvReport";
    UnderwritingReportName["HouseCanaryValueAnalysisReport"] = "HouseCanaryValueAnalysisReport";
    UnderwritingReportName["IncomeEntriesReport"] = "IncomeEntriesReport";
    UnderwritingReportName["ExpenseEntriesReport"] = "ExpenseEntriesReport";
    UnderwritingReportName["IrsReport"] = "IrsReport";
    UnderwritingReportName["LienAttestationReport"] = "LienAttestationReport";
    UnderwritingReportName["LoanApplicationReport"] = "LoanApplicationReport";
    UnderwritingReportName["SliderSelectionReport"] = "SliderSelectionReport";
    UnderwritingReportName["MailReport"] = "MailReport";
    UnderwritingReportName["ManualIncomeVerificationReport"] = "ManualIncomeVerificationReport";
    UnderwritingReportName["ManualLienInfoReport"] = "ManualLienInfoReport";
    UnderwritingReportName["ManualOfferReport"] = "ManualOfferReport";
    /**
     * Synthetic "report" that the multispec underwriting service emits when a spec evaluation
     * passes hardcuts but `OwnerNameMatchDecision` was REMEDY (e.g. single-token match against
     * the recorded owner name). The applicant must confirm or correct their name before any
     * offer can be honored. The orchestrator transitions the LA to `nameMismatchRemedy` and
     * routes the user through the existing remedy UI; once the LA reaches `nameMismatchVerified`
     * pre-qual UW re-runs against the corrected name and produces a real decision.
     */
    UnderwritingReportName["NameConfirmationReport"] = "NameConfirmationReport";
    UnderwritingReportName["PreQualAcceptedReport"] = "PreQualAcceptedReport";
    UnderwritingReportName["OcrolusReport"] = "OcrolusReport";
    UnderwritingReportName["IncomeVerificationConfigReport"] = "IncomeVerificationConfigReport";
    UnderwritingReportName["ApplicantIncomeVerificationConfigReport"] = "ApplicantIncomeVerificationConfigReport";
    UnderwritingReportName["PersonalPropertyAttestationInfoReport"] = "PersonalPropertyAttestationInfoReport";
    UnderwritingReportName["PlaidBalanceReport"] = "PlaidBalanceReport";
    UnderwritingReportName["PlaidBaseReport"] = "PlaidBaseReport";
    UnderwritingReportName["PlaidRecurringTransactionsReport"] = "PlaidRecurringTransactionsReport";
    UnderwritingReportName["PlaidReport"] = "PlaidReport";
    UnderwritingReportName["PlaidTransactionsReport"] = "PlaidTransactionsReport";
    UnderwritingReportName["TransUnionReport"] = "TransUnionReport";
    UnderwritingReportName["TrueworkReport"] = "TrueworkReport";
    UnderwritingReportName["PurchaseSettlementReport"] = "PurchaseSettlementReport";
    UnderwritingReportName["RequestedOfferTermsReport"] = "RequestedOfferTermsReport";
    UnderwritingReportName["BorrowerExistingAvenAccountsReport"] = "BorrowerExistingAvenAccountsReport";
    UnderwritingReportName["UccAssetVerificationReport"] = "UccAssetVerificationReport";
    UnderwritingReportName["UsCensusBureauReport"] = "UsCensusBureauReport";
    UnderwritingReportName["VehicleReport"] = "VehicleReport";
    UnderwritingReportName["VerifiedAssetReport"] = "VerifiedAssetReport";
    UnderwritingReportName["VestaLoanReport"] = "VestaLoanReport";
    UnderwritingReportName["WorkNumberReport"] = "WorkNumberReport";
    UnderwritingReportName["SupportedStatesReport"] = "SupportedStatesReport";
    UnderwritingReportName["PersonalFinancialLiabilitiesReport"] = "PersonalFinancialLiabilitiesReport";
    UnderwritingReportName["TargetLoanTermsReport"] = "TargetLoanTermsReport";
    UnderwritingReportName["Texas50a6AttestationReport"] = "Texas50a6AttestationReport";
    UnderwritingReportName["PropertyDetailsAttestationReport"] = "PropertyDetailsAttestationReport";
    UnderwritingReportName["ThirdPartyPreQualificationReport"] = "ThirdPartyPreQualificationReport";
    UnderwritingReportName["DebtSwapDtiRecoveryReport"] = "DebtSwapDtiRecoveryReport";
    UnderwritingReportName["PropertyValueAttestationReport"] = "PropertyValueAttestationReport";
    UnderwritingReportName["CryptoCollateralCommitmentReport"] = "CryptoCollateralCommitmentReport";
    UnderwritingReportName["MerchantDiscountRateReport"] = "MerchantDiscountRateReport";
})(UnderwritingReportName || (exports.UnderwritingReportName = UnderwritingReportName = {}));
/**  @TranslateToPython @TranslateToEnum  */
var PythonBucketProductType;
(function (PythonBucketProductType) {
    PythonBucketProductType["ZERO_REVOLVING_APR"] = "ZERO_REVOLVING_APR";
    PythonBucketProductType["DEFAULT"] = "DEFAULT";
    PythonBucketProductType["PRPP_BUCKET"] = "PRPP_BUCKET";
})(PythonBucketProductType || (exports.PythonBucketProductType = PythonBucketProductType = {}));
var UnderwritingResponseType;
(function (UnderwritingResponseType) {
    UnderwritingResponseType["DENIED"] = "DENIED";
    UnderwritingResponseType["INELIGIBLE"] = "INELIGIBLE";
})(UnderwritingResponseType || (exports.UnderwritingResponseType = UnderwritingResponseType = {}));
/**  @TranslateToPython  */
exports.ORIGINATION_HOME_UNDERWRITING_MODES = [HomeUnderwritingMode.origination, HomeUnderwritingMode.lienOverride];
/**  @TranslateToPython  */
var DebtSwapStrategy;
(function (DebtSwapStrategy) {
    // For old re-UW (MOFO, superCLI) policies, we don't support debt swap bonus.
    DebtSwapStrategy["NoDebtSwapBonus"] = "NoDebtSwapBonus";
    // https://docs.google.com/document/d/1UckWmQPpaEyZ-qjIsqgsUF17BEqnsgZytYOJOnGXkEo
    DebtSwapStrategy["FullDebtSwapBonus"] = "FullDebtSwapBonus";
    // Debt swap bonus controlled by FICO_TO_SWAP_BONUS_DICT in UW policy.
    DebtSwapStrategy["DebtSwapBonusWithFicoCap"] = "DebtSwapBonusWithFicoCap";
    /**
     * If we cannot generate an offer based on the applicant's DTI, then we should recalculate DTI removing
     * tradelines that we can balance transfer (i.e. using MethodFi), and recalculate DTI. This will generate a
     * contingency that the cardholder can clear by executing the balance transfer(s).
     */
    // TODO: Implement code to handle this strategy
    DebtSwapStrategy["DebtSwapBalanceTransferableTradelinesIfNecessaryV1"] = "DebtSwapBalanceTransferableTradelinesIfNecessaryV1";
    // Flex-specific: no DTI/line size bonus, but applies fixed-term APR incentive for debt swap.
    // The APR increase is waived if the user BTs >= line size.
    DebtSwapStrategy["FixedTermDebtSwapAprIncentive"] = "FixedTermDebtSwapAprIncentive";
    // Prequal debt-swap bonus based on user-selected tradelines from PFL report.
    // calcDebtSwapBonus returns monthlyPaymentOfAppliedSelectedDebtSwapTradelines feature value.
    DebtSwapStrategy["UserSelectedDebtSwapTradelines"] = "UserSelectedDebtSwapTradelines";
})(DebtSwapStrategy || (exports.DebtSwapStrategy = DebtSwapStrategy = {}));
/** @TranslateToPython */
exports.USER_SELECTED_PREQUAL_DEBT_SWAP_STRATEGIES = [DebtSwapStrategy.UserSelectedDebtSwapTradelines];
const supportsUserSelectedPrequalDebtSwap = (policy) => {
    return policy.DEBT_SWAP_STRATEGY != null && exports.USER_SELECTED_PREQUAL_DEBT_SWAP_STRATEGIES.includes(policy.DEBT_SWAP_STRATEGY);
};
exports.supportsUserSelectedPrequalDebtSwap = supportsUserSelectedPrequalDebtSwap;
const allowsOptionalUserSelectedPrequalDebtSwap = (policy, statedUsageType) => {
    // Old policies that don't have this attribute default to "allowed" because that was the legacy behavior
    if (!policy.STATED_USAGE_THAT_ALLOWS_OPTIONAL_OG_DEBT_SWAP) {
        return true;
    }
    // If the LA doesn't have a statedUsage for some reason, we won't allow debt swap because
    // allowing debt swap creates a more noisy UI and undue cognitive load on the applicant.
    if (!statedUsageType) {
        return false;
    }
    return policy.STATED_USAGE_THAT_ALLOWS_OPTIONAL_OG_DEBT_SWAP.includes(statedUsageType);
};
exports.allowsOptionalUserSelectedPrequalDebtSwap = allowsOptionalUserSelectedPrequalDebtSwap;
/** @TranslateToPython */
var TeaserRateFeatureType;
(function (TeaserRateFeatureType) {
    TeaserRateFeatureType["NoTeaserRate"] = "NoTeaserRate";
    // Teaser promotion rate on the SIP created for second lien balance payoff in Heloc Refi.
    // The associated policy is Heloc Refi MOAP teaser rate policy.
    TeaserRateFeatureType["HelocRefiPriorLienPayoffFee"] = "HelocRefiPriorLienPayoffFee";
    // Teaser promotion rate on the SIP created for both second lien balance payoff and upfront draw of residual line size in Heloc Refi.
    // The associated policy is Heloc Refi Aven Cash teaser rate policy.
    TeaserRateFeatureType["HelocRefiFirstDrawFee"] = "HelocRefiFirstDrawFee";
})(TeaserRateFeatureType || (exports.TeaserRateFeatureType = TeaserRateFeatureType = {}));
/**  @TranslateToPython  */
var AllLiensAttestationTrigger;
(function (AllLiensAttestationTrigger) {
    AllLiensAttestationTrigger["INACCURATE_MORTGAGE_INFO"] = "INACCURATE_MORTGAGE_INFO";
    AllLiensAttestationTrigger["MULTIPLE_LIENS"] = "MULTIPLE_LIENS";
    AllLiensAttestationTrigger["ZERO_BALANCE_LIEN"] = "ZERO_BALANCE_LIEN";
    // Attest the liens we intend to refinance, whenever any of them was actually detected.
    AllLiensAttestationTrigger["LIENS_TO_REFI"] = "LIENS_TO_REFI";
    AllLiensAttestationTrigger["EXPERIAN_ONLY_MORTGAGE_EVIDENCE"] = "EXPERIAN_ONLY_MORTGAGE_EVIDENCE";
    AllLiensAttestationTrigger["DUPLICATE_MORTGAGE_TRADELINES"] = "DUPLICATE_MORTGAGE_TRADELINES";
})(AllLiensAttestationTrigger || (exports.AllLiensAttestationTrigger = AllLiensAttestationTrigger = {}));
/** @TranslateToPython */
exports.LOW_CONFIDENCE_LIEN_ATTESTATION_TRIGGERS = [AllLiensAttestationTrigger.EXPERIAN_ONLY_MORTGAGE_EVIDENCE, AllLiensAttestationTrigger.DUPLICATE_MORTGAGE_TRADELINES];
/**
 * Strategy for consolidating lien from source data and filtering consolidated liens in underwriting calculations.
 * @TranslateToPython
 */
var LienTradelineConsolidationStrategy;
(function (LienTradelineConsolidationStrategy) {
    /** Filter out consolidated liens that (do not have lienPosition AND have zero/None balance).
     *  Also set lienPosition in the consolidated lien info object based on the lien position from the source data.
     *  @deprecated as of 10/6/2025 because logic was found to already exist in default branch.
     */
    LienTradelineConsolidationStrategy["ENHANCED_FILTERING"] = "ENHANCED_FILTERING";
    /**
     * In underwriting we need to deduplicate tradelines that come from different sources (e.g. Experian and MethodFi
     * in creditComputation#getUnsecuredLoansInBothMethodFiAndBureau). This enum defines the strategy we use to
     * perform the deduplication.
     */
    LienTradelineConsolidationStrategy["ALLOW_FUZZY_MATCH_OF_ACCOUNT_OPEN_DATE_AND_CREDIT_LIMIT"] = "ALLOW_FUZZY_MATCH_OF_ACCOUNT_OPEN_DATE_AND_CREDIT_LIMIT";
    LienTradelineConsolidationStrategy["REQUIRE_STRICT_MATCH_OF_ACCOUNT_OPEN_DATE_AND_CREDIT_LIMIT"] = "REQUIRE_STRICT_MATCH_OF_ACCOUNT_OPEN_DATE_AND_CREDIT_LIMIT";
    // Fix bug in computing lien-tradeline start date gap.
    LienTradelineConsolidationStrategy["FIX_BUG_IN_COMPUTING_LIEN_TRADELINE_START_DATE_GAP_20251104"] = "FIX_BUG_IN_COMPUTING_LIEN_TRADELINE_START_DATE_GAP_20251104";
    // Use CL involuntary liens report for lien retrieval.
    LienTradelineConsolidationStrategy["USE_CL_INVOLUNTARY_LIENS_REPORT_FOR_LIEN_RETRIEVAL"] = "USE_CL_INVOLUNTARY_LIENS_REPORT_FOR_LIEN_RETRIEVAL";
    // Match based on date if either original loan amount is missing.
    LienTradelineConsolidationStrategy["MATCH_BASED_ON_DATE_IF_LOAN_AMOUNT_MISSES_IN_ONE_PARTY"] = "MATCH_BASED_ON_DATE_IF_LOAN_AMOUNT_MISSES_IN_ONE_PARTY";
})(LienTradelineConsolidationStrategy || (exports.LienTradelineConsolidationStrategy = LienTradelineConsolidationStrategy = {}));
/**  @TranslateToPython  */
var DollarAmountIncentiveRoute;
(function (DollarAmountIncentiveRoute) {
    DollarAmountIncentiveRoute["PREQUALIFICATION"] = "PREQUALIFICATION";
    DollarAmountIncentiveRoute["CONCIERGE"] = "CONCIERGE";
    DollarAmountIncentiveRoute["ACCOUNT_OPENING"] = "ACCOUNT_OPENING";
})(DollarAmountIncentiveRoute || (exports.DollarAmountIncentiveRoute = DollarAmountIncentiveRoute = {}));
/**  @TranslateToPython  */
var DollarAmountIncentiveType;
(function (DollarAmountIncentiveType) {
    DollarAmountIncentiveType["AMAZON_GIFT_CARD"] = "AMAZON_GIFT_CARD";
})(DollarAmountIncentiveType || (exports.DollarAmountIncentiveType = DollarAmountIncentiveType = {}));
// ---------------------------------------------------------------------------
// UW Product Metadata
// ---------------------------------------------------------------------------
/**
 * Classifies how a product participates in a multi-product offering.
 *
 * ADVERTISED — primary, user-facing product. Drives the overall approval/denial decision.
 * ALTERNATIVE — backup/upsell product. Does not affect overall decisioning.
 *
 * @TranslateToPython
 */
var ProductOfferingType;
(function (ProductOfferingType) {
    /**
     * User-facing entry. Denial is determined by whether ANY variant in this entry produces an offer.
     * Must have at least one variant set capable of producing adverse action notice data.
     */
    ProductOfferingType["ADVERTISED"] = "advertised";
    /**
     * Backup/upsell entry. Does not affect overall approval/denial decision.
     */
    ProductOfferingType["ALTERNATIVE"] = "alternative";
    /**
     * Upgrade entry. Offers are persisted but excluded from ranking, surfacing,
     * and the prequal response. Retrieved on demand by upgrade flows
     * (e.g. blenderHomeUpgradeManager) via the Offer entity table.
     */
    ProductOfferingType["UPGRADE"] = "upgrade";
})(ProductOfferingType || (exports.ProductOfferingType = ProductOfferingType = {}));
